import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';
import { autoLanguageDetector } from '../../i18n/i18n';
import { inIframe } from '../../screens/Home/Share';

const shopLanguageCodes = {
  fr: '',
  en: 'en',
  es: 'es',
  pt: 'pt',
};
const getShopLanguageCode = (languageCode = autoLanguageDetector()) => {
  return shopLanguageCodes[languageCode];
};

const BackToShopButton = () => {
  const { t, language } = useContext(AppContext);
  if (inIframe()) return <></>;
  return (
    <a
      href={`https://www.sowelab.com/${getShopLanguageCode(language)}`}
      className="button"
    >
      {t('back_to_shop')}
    </a>
  );
};

export default BackToShopButton;
